import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import { smTitle } from '@ifca-root/react-component/src/global/TitleVariable'
import { TotalAmountFooter } from 'components/Footer/TotalAmountFooter'
import React, { useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { ConsolidateTable } from '../../../ARAPModule/ConsolidateTable/ConsolidateTable'
import { useGetCompanyNameQuery } from 'generated/graphql'
import { ConsolidateSelfBilledDetailContent } from './ConsolidateSelfBilledDetailContent'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'

export const ConsolidateSelfBilledDetail = (props: any) => {
  /* ------------------------------------------- */
  /*                 VARIABLES                   */
  /* ------------------------------------------- */

  let history = useHistory()
  let location = useLocation()
  const listData = location?.state as any
  const { CompanyID }: any = useParams()

  /* ------------------------------------------- */
  /*                 USE STATE                   */
  /* ------------------------------------------- */

  const [labelState, setLabelState] = useState<string>()
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  /* --------------------------------------- */
  /*                 QUERY                   */
  /* --------------------------------------- */

  const {
    loading: CompanyLoading,
    error: CompanyError,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID },
    onCompleted: () => {
      if (!!getCompany) setLabelState(getCompany[0]?.Name)
    },
  })

  /* ------------------------------------------ */
  /*                 FUNCTION                   */
  /* ------------------------------------------ */

  const totalDocAmt = listData?.eInvoiceConsolidationDetail?.reduce(
    (total, current) => total + Number(current?.DocAmt),
    0
  )

  const totalTaxAmt = listData?.eInvoiceConsolidationDetail?.reduce(
    (total, current) => total + Number(current?.TaxAmt),
    0
  )

  return (
    <>
      <MainHeader
        mainBtn={'close'}
        onClick={() =>
          history.push({
            pathname: `/account-payable/${CompanyID}/consolidate-self-billed`,
          })
        }
        smTitle={smTitle.ACCOUNT_PAYABLE}
        title={labelState}
        routeSegments={[
          { name: 'Account Payable' },
          { name: `Consolidate Self-Billed`, current: true },
        ]}
        rightRouteSegments={[{ name: 'View', current: true }]}
      />

      <DynamicSubHeader
        title={
          <>
            <span className="xsTitle" style={{ color: '#ff9800' }}>
              {listData?.DocNo}
            </span>
          </>
        }
        rightText={
          <span className="c-orange">{formatDate(listData?.DocDate)}</span>
        }
      />

      <ContentWrapper singleDynamicInfo float>
        <CardContents>
          <ConsolidateSelfBilledDetailContent listEl={listData} />
        </CardContents>

        <CardContents
          section={{
            header: {
              title: `Consolidated Detail(s)`,
              customFontSizeClass: 'xsTitle',
            },
          }}
        >
          <ConsolidateTable
            creditorOrDebtor={'Creditor'}
            data={listData?.eInvoiceConsolidationDetail}
          />
        </CardContents>
      </ContentWrapper>

      <TotalAmountFooter
        isDetail={true}
        countRecord={
          listData?.eInvoiceConsolidationDetail?.length > 0
            ? listData?.eInvoiceConsolidationDetail?.length
            : 0
        }
        taxInfoDetailWithRecord={true}
        docAmt={totalDocAmt}
        totalTaxAmt={totalTaxAmt}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
